var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"api-key":"m5mpk7a95lmje12uxy35dvtdslxden046n6mvv09mllp7ww0","init":_vm.initEditor,"value":_vm.content},on:{"input":_vm.onchangeContent}})}
var staticRenderFns = []

export { render, staticRenderFns }